import type { OperationTypeIcon } from '@/shared/types';
import { useDictionary } from './useDictionary';

const useOperationTypesIcons = () => {
  const {
    data: operationTypeIconsData,
    isLoading: isOperationTypesIconsLoading,
    refetch: refetchOperationTypesIcons,
  } = useDictionary<Array<OperationTypeIcon>>({
    dictionaryName: 'operationtypesicons',
  });

  return {
    operationTypeIconsData,
    isOperationTypesIconsLoading,
    refetchOperationTypesIcons,
  };
};

export { useOperationTypesIcons };
